module.exports = __webpack_public_path__ + "static/media/walee-logo.f327677a.png";